import api, { USE_MOCK, qs } from './apiClient';
import mockApi from '../mock/backend';

export const searchService = {
  search(params) {
    if (USE_MOCK) return mockApi.search(params);
    return api.get(`/search${qs(params)}`);
  },

  suggest(q, options) {
    if (USE_MOCK) return mockApi.suggest(q);
    return api.get(`/search/suggest?q=${encodeURIComponent(q)}`, options);
  },

  ai(question) {
    if (USE_MOCK) return mockApi.aiSearch(question);
    return api.post('/search/ai', { query: question });
  },

  /** Documents that read like this one. Returns `{ available, results }`. */
  similar(documentId, options) {
    if (USE_MOCK) return Promise.resolve({ available: false, results: [] });
    return api.get(`/search/similar/${documentId}`, options);
  },
};

export default searchService;
